<template>
  <SogPage
    title="Impressum"
    flex-direction="flex-column"
  >
    <div>
      <p class="">
        <strong>1. Angaben gemäß § 5 des deutschen Telemediengesetzes</strong>
      </p>
      <p class="" />
      <p class="">
        Agent 22 GmbH <br>Kaiser-Wilhelm-Str. 93 <br>20355 Hamburg, Deutschland
      </p>
      <p class="">
        Geschäftsführer: Martins Grants, Ambroise Fargere
      </p>
      <p class="">
        <a
          class="c-link"
          href="https://www.handelsregister.de/rp_web/welcome.xhtml"
          target="_blank"
          rel="noopener noreferrer"
        >Handelsregister</a>: Amtsgericht Hamburg HRB 151446 <br><a
          class="c-link"
          href="https://agent22.eu/error"
          target="_blank"
        >Versicherungsvermittlerregister</a>: D-TQJ0-V43WS-53
      </p>
      <p class="">
        USt-IdNr. DE354721093
      </p>
      <p class="">
        Mitglied der <a
          class="c-link"
          href="http://www.hk24.de/"
          target="_blank"
          rel="noopener noreferrer"
        >Handelskammer Hamburg</a>, Adolphsplatz 1, 20457 Hamburg, Deutschland
      </p>
      <p class="">
        Erlaubnis nach § 34d Abs. 1 der Gewerbeordnung (GewO) Aufsichtsbehörde: <a
          class="c-link"
          href="http://www.hk24.de/"
          target="_blank"
          rel="noopener noreferrer"
        >Handelskammer Hamburg</a>, Adolphsplatz 1, 20457 Hamburg, Deutschland <br>
      </p>
      <p class="">
        Berufsbezeichnung in Bezug auf die erlaubnispflichtige Tätigkeit: Versicherungsvertreter; Bundesrepublik
        Deutschland
      </p>
      <p class="">
        Berufsrechtliche Regelungen: § 34d Gewerbeordnung (GewO), §§ 59-68 Versicherungsvertragsgesetz (VVG) und
        Versicherungsvermittlerverordnung (VersVermV).
      </p>
      <p class="">
        Die berufsrechtlichen Regelungen können über die vom Bundesministerium der Justiz in Kooperation mit der juris
        GmbH betriebene Homepage <a
          class="c-link"
          href="http://www.gesetze-im-internet.de/"
          target="_blank"
          rel="noopener noreferrer"
        >gesetze-iminternet.de</a> eingesehen und abgerufen werden.
      </p>
      <p class="">
        Verantwortlich für den Inhalt: Stefanie Koch
      </p>
      <p class="" />
      <p class="">
        <strong>2. Haftung für Inhalte</strong>
      </p>
      <p class="">
        Obwohl wir alle Informationen und Bestandteile dieser Webseite nach bestem Wissen und Gewissen zusammengestellt
        haben, haften wir nicht für die Vollständigkeit, Richtigkeit, Aktualität und technische Exaktheit der auf dieser
        Webseite bereitgestellten Informationen. Ebenso wenig haften wir für etwaige Schäden, die beim Aufrufen oder
        Herunterladen von Daten aus dieser Webseite durch Computerviren verursacht werden.
      </p>
      <p class="" />
      <p class="">
        <strong>3. Haftung für Links</strong>
      </p>
      <p class="">
        Unsere Webseite enthält Links zu Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb
        übernehmen wir für diese fremden Inhalte keine Gewähr. Für die Inhalte der verlinkten Seiten ist stets der
        jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die Webseite enthält insbesondere einen Link zu
        unserem Kundenportal („Kunden-Login“), dessen Nutzung besonderen Bedingungen unterliegt.
      </p>
      <p class="" />
      <p class="">
        <strong>4. Urheberrecht</strong>
      </p>
      <p class="">
        Die durch uns erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die
        Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes
        bedürfen unserer Zustimmung. Soweit die Inhalte auf dieser Seite nicht von uns erstellt wurden, werden die
        Urheberrechte Dritter beachtet.
      </p>
      <p class="" />
      <p class="">
        <strong>5. Marke</strong>
      </p>
      <p class="">
        Unser Name und unser Logo sind markenrechtlich geschützt. Auch andere Firmenbezeichnungen, Firmenlogos und
        Produktnamen, die auf unserer Webseite genannt werden, können geschützte Marken der jeweiligen Inhaber sein.
      </p>
    </div>
  </SogPage>
</template>

<script setup lang="ts">
import SogPage from "@/shared/ui/SogPage.vue";
</script>
<style scoped>
</style>
